export default "__VITE_ASSET__Cs0yX4jl__"